import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/form.less';
import 'semantic-ui-less/definitions/modules/checkbox.less';

// Custom select that overrides clear search query
class DropdownDisableInputClear extends React.Component {
  constructor(props) {
    super(props);

    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    // eslint-disable-next-line
    this.dropdownRef.current.clearSearchQuery = value => {
      this.dropdownRef.current.setSelectedIndex(value, undefined, '');
    };
  }

  render() {
    return <Dropdown {...this.props} ref={this.dropdownRef} selection />;
  }
}

export default DropdownDisableInputClear;
